
import React, { useState } from "react";
import { useCopilot } from "@/contexts/CopilotContext";

export const AgentBox: React.FC = () => {
  const { setCopilotOpen } = useCopilot();
  const [messages, setMessages] = useState([
    { role: "system", content: "Hi! I'm your Copilot Agent. Ask me anything about this page, SQL, or performance!" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  // Placeholder for Copilot API integration
  const handleSend = async () => {
    if (!input.trim()) return;
    setLoading(true);
    setMessages([...messages, { role: "user", content: input }]);
    // Simulate agent response
    setTimeout(() => {
      setMessages(msgs => [
        ...msgs,
        { role: "assistant", content: "(Copilot would answer here. This is a placeholder.)" }
      ]);
      setLoading(false);
    }, 1200);
    setInput("");
  };




  return (
  <aside className="w-[260px] h-screen min-h-0 max-h-none flex flex-col border-l border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg fixed right-0 top-0 z-40">
      {/* Hide button on the left edge, arrow points left (❮) when visible */}
      <button
        onClick={() => setCopilotOpen(false)}
        className="absolute left-0 top-1/2 -translate-x-full -translate-y-1/2 bg-shiftleft-600 text-white px-2 py-1 rounded-l shadow z-50 hover:bg-shiftleft-700"
        style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
        title="Hide Copilot"
      >
        <span className="text-lg">❮</span>
      </button>
      <div className="p-4 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-950 flex items-center justify-between">
        <div className="font-bold text-lg text-shiftleft-700 dark:text-shiftleft-300 flex items-center gap-2">
          <span>🧑‍💻</span> Agent Copilot
        </div>
        <button
          onClick={() => setCopilotOpen(false)}
          className="ml-4 px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 text-xs"
          title="Close Copilot"
        >✕</button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {messages.map((msg, i) => (
          <div key={i} className={`text-sm rounded px-3 py-2 ${msg.role === "user" ? "bg-shiftleft-50 text-shiftleft-900 self-end ml-10" : msg.role === "assistant" ? "bg-green-50 text-green-900 self-start mr-10" : "bg-gray-100 text-gray-700 self-center"}`}>{msg.content}</div>
        ))}
        {loading && <div className="text-xs text-gray-400">Thinking...</div>}
      </div>
      <form className="p-3 border-t border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-950 flex gap-2" onSubmit={e => { e.preventDefault(); handleSend(); }}>
        <input
          className="flex-1 rounded border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm bg-white dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-shiftleft-400"
          placeholder="Ask Copilot..."
          value={input}
          onChange={e => setInput(e.target.value)}
          disabled={loading}
        />
        <button
          type="submit"
          className="bg-shiftleft-600 hover:bg-shiftleft-700 text-white px-4 py-2 rounded text-sm font-semibold disabled:opacity-60"
          disabled={loading || !input.trim()}
        >
          Send
        </button>
      </form>
    </aside>
  );
};
